@import './pk-avatar.variables';

:host {
  @apply inline-block;
}

.pk-avatar {
  @apply button-reset relative block h-[--avatar--size] w-[--avatar--size] rounded-[50%] bg-[color:--avatar--bg];
}

.pk-avatar.type-text {
  // Applying `translate(-100%, -100%);` will make the badge
  // to cover part of the text inside the avatar,
  // to avoid it we need to increase the distance.
  .pk-avatar--badge {
    @apply -translate-x-3/4 -translate-y-3/4;
  }
}

.pk-avatar--text {
  background: var(--avatar--custom-bg);

  ::slotted([slot='text']) {
    @apply -translate-x-2/4 -translate-y-2/4 #{!important};
    @apply absolute left-2/4 top-2/4 font-semibold text-m text-text-01;
  }
}
